export function formatDateView_Old(date) {
    if (date == null || date == '') return null;

    return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
}

export function formatDateDash_Old(date) {
    if (!date) return "";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
}

export function formatDateAll(date, separator = "/") {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d)) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}${separator}${month}${separator}${year}`;
}

export function formatDateView(date) {
  return formatDateAll(date , "/");
}

export function formatDateDash(date) {
  return formatDateAll(date , "-");
}

export function shipModeLabel(datakey) {
    const result = {
        by_sea: "By Sea",
        by_road: "By Road",
        by_air: "By Air",
    };

    return result[datakey] || "";
}
export function payModeLabel(datakey) {
    const result = {
        freight_collect: "Freight Collect",
        freight_prepaid: "Freight Prepaid",
    };

    return result[datakey] || "";
}
export function categoryLabel(datakey) {
    const result = {
        brand: "Brand",
        non_copy: "Non-Copy",
        normal_copy: "Normal Copy",
        copy_and_brand: "Copy & Brand",
    };

    return result[datakey] || "";
}
export function calTypeLabel(datakey) {
    const result = {
        cbm: "CBM",
        ctn: "Carton/Bag",
        kg:  "KG",
    };

    return result[datakey] || "";
}

export function incrementTypes(datakey) {
    const result = {
        normal: "Normal",
        performance: "Performance",
        promotion:  "Promotion",
        Special:  "Special",
    };
    return result[datakey] || "";
}

export function getShipModes() {
    return [
        { name: 'by_sea', display_text: 'By Sea' },
        { name: 'by_road', display_text: 'By Road' },
        { name: 'by_air', display_text: 'By Air' },
    ];
}

export function formatBDNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === '') {
    return decimals > 0 ? '0.' + '0'.repeat(decimals) : '0';
  }

  return Number(value).toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

export function formatBDCurrency(value, symbol = '৳') {
  const amount = formatBDNumber(value, 2);
  return `${symbol} ${amount}`;
}

export function formatUSD(value, decimals = 2) {
  if (value === null || value === undefined || value === '') {
    return decimals > 0 ? '0.' + '0'.repeat(decimals) : '0';
  }

  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

export function formatUSDCurrency(value, symbol = '$') {
  const amount = formatUSD(value, 2);
  return `${symbol}${amount}`;
}

export function formatCurrency(value, type = 'BD') {
  const config = {
    BD: { symbol: '৳', locale: 'en-IN', space: true },
    USD: { symbol: '$', locale: 'en-US', space: false }
  };

  const { symbol, locale, space } = config[type] || config.BD;
  const amount = number_format(value, 2, type);

  return space ? `${symbol} ${amount}` : `${symbol}${amount}`;
}

export function number_format(value, decimals = 2, type = 'BD') {
  if (value === null || value === undefined || value === '') {
    return decimals > 0 ? '0.' + '0'.repeat(decimals) : '0';
  }

  const locale = type === 'USD' ? 'en-US' : 'en-IN';

  return Number(value).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

export function getCompanyInfo() {
  try {
    const result = localStorage.getItem('company_info');
    return result ? JSON.parse(result) : null;
  } catch (e) {
    return null;
  }
}